import React from 'react'
import { CountryDto } from '@/api/Identity/Types/Country'
import { CJMFiltersDto } from '@/api/Metrics/Types/CJMDto'
import { FormCheckboxField, FormMultiSelectField } from '@/components/Form/FormField'
import { LoadingOverlay } from '@/components/LoadingOverlay/LoadingOverlay'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { FormSubmitValues } from '@/utils/formValidation'
import { Form, FormikProps, withFormik } from 'formik'

interface CJMFiltersFormValues {
  clientCountryIds?: string[]
  ibCountryIds?: string[]
  hasMainIb?: boolean
}

interface OuterProps {
  isOpen?: boolean
  data: CJMFiltersDto | undefined
  countries: CountryDto[]
  onClose: () => void
  resetFilters: () => void
  onSubmit: (values: FormSubmitValues<CJMFiltersDto>) => void
}

type CJMFiltersFormProps = FormikProps<CJMFiltersFormValues> & OuterProps

const CJMFiltersFormUI: React.FC<CJMFiltersFormProps> = (props) => {
  const { handleSubmit, isSubmitting, setFieldValue, countries, isOpen, onClose, resetFilters } =
    props

  const getCountyOptions = () =>
    countries.map((country) => {
      return {
        id: country.id,
        name: country.name,
      }
    })

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Clients activation tracking</DialogTitle>
        </DialogHeader>
        <Form>
          <div className='flex flex-col gap-4'>
            <FormMultiSelectField
              name='clientCountryIds'
              label='Client country'
              placeholder='Select country'
              options={getCountyOptions()}
              showSearch
              allowClear
              onChange={(value) => setFieldValue('clientCountryIds', value)}
            />
            <FormMultiSelectField
              name='ibCountryIds'
              label='IB country'
              placeholder='Select country'
              options={getCountyOptions()}
              showSearch
              allowClear
              onChange={(value) => setFieldValue('ibCountryIds', value)}
            />
            <FormCheckboxField name='hasMainIb' label="Client's main code is under an IB" />
          </div>
        </Form>
        <DialogFooter>
          <Button variant='destructive' onClick={resetFilters}>
            Reset
          </Button>
          <Button type='button' onClick={() => handleSubmit()} disabled={!props.isValid}>
            Apply Filters
          </Button>
        </DialogFooter>
        <LoadingOverlay isLoading={isSubmitting} />
      </DialogContent>
    </Dialog>
  )
}

export const CJMFiltersForm = withFormik<OuterProps, CJMFiltersFormValues>({
  mapPropsToValues: (props) => {
    const { data } = props

    return {
      clientCountryIds: data?.clientCountryIds,
      ibCountryIds: data?.ibCountryIds,
      hasMainIb: data?.hasMainIb,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      setSubmitting(true)
      const data = dataToSubmit(values)
      props.onSubmit(data)
    } finally {
      setSubmitting(false)
    }
  },
  enableReinitialize: true,
})(CJMFiltersFormUI)

const dataToSubmit = (values: CJMFiltersFormValues) => {
  return {
    clientCountryIds: values?.clientCountryIds,
    ibCountryIds: values?.ibCountryIds,
    hasMainIb: values?.hasMainIb,
  }
}
